import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { GoalsTableContent } from './GoalsTableContent';
import { GoalsTableHeader } from './GoalsTableHeader';

const Table = styled.div`
  display: grid;
  padding: ${spacing.base} 0;
  margin-top: ${spacing.base};
  min-height: 100%;
  min-width: ${pxToRem(1100)};
`;

export const GoalsPageTable = () => {
  return (
    <Table data-test="goals-table">
      <GoalsTableHeader />
      {/*
      TODO: Implement bulk actions if supported
      {showBulkActionBar && <BulkActionsBar actions={bulkActions} numSelected={bulk.length} />}
      */}
      <GoalsTableContent />
    </Table>
  );
};
